import styled from 'styled-components';

export const CartPreviewItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  padding-bottom: 24px;
  border-bottom: 2px solid ${Styles.color.grey.six};
`;
